import React, { Component, createContext } from 'react';
import axios from 'axios';

import * as api from '../../lib/api/api';
import * as PATH from '../../lib/routes/path';
import { ERROR_CS } from '../../lib/Error';

const AuthContext = createContext();
export default AuthContext;

const { Provider, Consumer: AuthConsumer } = AuthContext;
const BABYFACE = 'BABYFACE';

class AuthProvider extends Component {
  state = {
    logged: false,
    prevUrl: '',
    isLoading: false,
  };

  constructor(props) {
    super(props);
    if (sessionStorage.accessToken) {
      axios.defaults.headers.common.Authorization = sessionStorage.accessToken;

      if (sessionStorage.logged === 'true') {
        this.state = {
          logged: true,
          prevUrl: '',
        };
      }
    }
  }

  actions = {
    signin: ({ email, password }) => {
      this.setState({
        isLoading: true,
      });
      return api
        .babyfaceSignin({ email, password })
        .then((response) => {
          const accessToken = response.data;
          axios.defaults.headers.common.Authorization = accessToken;
          sessionStorage.accessToken = accessToken;
          sessionStorage.logged = 'true';
          this.setState({
            logged: true,
          });
          return true;
        })
        .finally(() =>
          this.setState({
            isLoading: false,
          }),
        );
    },
    signinNaver: ({ accessToken }) => {
      const businessName = BABYFACE;
      return api
        .babyfaceSigninNaver({ accessToken, businessName })
        .then((response) => {
          const { accessToken, isNew } = response.data;
          axios.defaults.headers.common.Authorization = accessToken;
          sessionStorage.accessToken = accessToken;
          if (!isNew) {
            sessionStorage.logged = 'true';
            this.setState({
              logged: true,
            });
          } else {
            window.location.replace(PATH.SIGNUP_SNS);
          }
        })
        .catch(() => {
          alert(`네이버 회원가입 도중 에러가 발생했습니다.\n${ERROR_CS}`);
          window.location.replace(PATH.SIGNUP);
        });
    },
    // 공식 문서 3.4.4: 네이버 토큰 교환 API
    signinNaverWithCode: ({ code, state }) => {
      const businessName = BABYFACE;
      return api
        .babyfaceSigninNaverWithCode({ code, state, businessName })
        .then((response) => {
          const { accessToken, isNew } = response.data;
          axios.defaults.headers.common.Authorization = accessToken;
          sessionStorage.accessToken = accessToken;
          if (!isNew) {
            sessionStorage.logged = 'true';
            this.setState({
              logged: true,
            });
          } else {
            window.location.replace(PATH.SIGNUP_SNS);
          }
        })
        .catch(() => {
          alert(`네이버 회원가입 도중 에러가 발생했습니다.\n${ERROR_CS}`);
          window.location.replace(PATH.SIGNUP);
        });
    },
    signout: () => {
      this.setState({
        isLoading: true,
      });
      return api
        .babyfaceSignout()
        .then((response) => {
          this.setState({
            loggged: false,
          });
          sessionStorage.clear();
          window.location.replace(PATH.HOME);
        })
        .catch((error) => {
          // alert(ERROR_RETRY); 로그아웃 시 에러 발생하는 경우가 많아 프론트에서 강제 로그아웃 처리
          this.setState({
            loggged: false,
          });
          sessionStorage.clear();
          window.location.replace(PATH.HOME);
        })
        .finally(() =>
          this.setState({
            isLoading: false,
          }),
        );
    },
    setPrevUrl: (currentUrl) => {
      this.setState({
        prevUrl: currentUrl,
      });
    },
    setLogged: () => {
      sessionStorage.logged = 'true';
      this.setState({
        logged: true,
      });
    },
  };

  render() {
    const context = {
      state: this.state,
      actions: this.actions,
    };

    return <Provider value={context}>{this.props.children}</Provider>;
  }
}

export { AuthConsumer, AuthProvider };
